import { fetcher } from '../../utils/fetchers/fetcher';
import { resolveApiPath } from '../../utils/resolveApiPath';

export const updateDatasetData = (
  api: string,
  //TODO: Create body type
  body: any,
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> =>
  fetcher<any>(
    resolveApiPath(api),
    'PUT',
    token,
    forceHeader,
    undefined,
    body,
    undefined,
    undefined
  );
